import axios from "axios";
import CommonApi from "./CommonApi";


export default class GoAroundApi {
    static async addGoAroundData(ConstructionSiteId,Data){
        const res=await axios.post( CommonApi.getHost()+"/GoAround/addGoAroundData",  {GoAround:{ConstructionSiteId:ConstructionSiteId, Data:Data}})
        return res.data;
    }
    static async addImage(Image, House, Floor, frontId){
        const FormData=new window.FormData();
        FormData.append('image', Image)
        FormData.append('house', House)
        FormData.append('floor', Floor)
        FormData.append('frontId', frontId)
        const res=await axios.post( CommonApi.getHost()+"/GoAround/addImage",  FormData)
        return res.data;
    }
    static async getImages(date){
        const params={
            params:{
                date:date
            }
        }
        const res=await axios.get( CommonApi.getHost()+"/GoAround/getImages",  params)
        return res.data;
    }
}